import { isPromise } from 'bold-ui'
import { handleError } from 'components/error'
import { ErrorObject } from 'util/validation'

import { ResultType } from './Form'

export async function defaultTransformResult<T = any>(
  result: ResultType,
  suppressNotificationError: boolean,
  suppressValidationError: boolean,
  supressFieldValidationNotificationError: boolean
): Promise<void | ErrorObject<T>> {
  if (!result || !isPromise(result)) {
    return result
  }

  try {
    // Descarta o valor resolvido: o FetchResult da mutation viraria submitErrors se repassado.
    await result
  } catch (error) {
    if (isSubmitErrors<T>(error)) {
      return error
    }

    // final-form trata undefined como sucesso; fallbackToFormError marca o submit como falho.
    return handleError({
      error,
      suppressNotificationError,
      suppressValidationError,
      supressFieldValidationNotificationError,
      fallbackToFormError: true,
    })
  }
}

/** Objeto simples de erros vira submitErrors do final-form; instâncias de Error seguem para o handleError. */
function isSubmitErrors<T>(error: unknown): error is ErrorObject<T> {
  if (typeof error !== 'object' || error === null || Array.isArray(error) || error instanceof Error) {
    return false
  }

  const candidate = error as Record<string, unknown>
  return !candidate.graphQLErrors && !candidate.networkError
}
